import React from 'react'
import { CandidateLinkShell } from '../components/CandidateLinkShell'

/**
 * A public notice for bearer-link uploads. It deliberately needs no client
 * lookup: the code is never sent to a careers-page resolver or analytics.
 */
const CandidatePrivacyNotice: React.FC = () => (
  <CandidateLinkShell>
    <h1 className="text-2xl">Document upload privacy notice</h1>
    <p className="mt-4 text-base" style={{ color: 'var(--link-ink-soft)' }}>
      Documents you send through this link are stored securely for your application
      and shared only with the employer you applied to.
    </p>
    <p className="mt-4 text-base" style={{ color: 'var(--link-ink-soft)' }}>
      Do not send documents you do not want considered as part of that application.
      You can close this page without uploading anything.
    </p>
  </CandidateLinkShell>
)

export default CandidatePrivacyNotice
